var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('Title',{attrs:{"data":_vm.data}}),_c('Batch',{staticStyle:{"margin-bottom":"20px"},attrs:{"title":"教师总结","text":"教师总结","list":_vm.form.teacher_summary}}),_c('div',{staticClass:"bottom_btn"},[_c('el-button',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("返回")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }